import { fetchSimulatedRedemption, type RedemptionQuoteResponse } from "@/services";
import { REDEEM_EVENTS } from "@/events";
import { useEventListener, useDialogPortal } from "@/hooks";
import { useTokenForm } from "@/hooks";
import { TOKEN_IDS } from "@/types";
import { useEffect, useState } from "react";

export function useRedeemFormAlt({ initialAmount = 0 }: { initialAmount?: number }) {
    const {
        form,
        amount: redeemAmount,
        amountError: redeemAmountError,
        selectedTokenId,
        selectTokenId,
        setMaxAmount,
        resetAmount,
        isAmountOverBalance,
    } = useTokenForm({
        defaultTokenId: TOKEN_IDS.IUSD,
        initialAmount,
    });

    const { openRedeemTransactionDialog } = useDialogPortal();
    useEventListener(REDEEM_EVENTS.SUCCESS, resetAmount);

    const [simulatedExit, setSimulatedExit] = useState<RedemptionQuoteResponse | null>(null);
    const [loadingSim, setLoadingSim] = useState(false);
    const [simError, setSimError] = useState<string | null>(null);

    useEffect(() => {
        const fetchQuote = async () => {
            setLoadingSim(true);
            setSimError(null);
            try {
                const response = await fetchSimulatedRedemption(Number(redeemAmount.value) * 1e18);
                setSimulatedExit(response);
            } catch (_err) {
                setSimError("Failed to estimate redemption");
            } finally {
                setLoadingSim(false);
            }
        };

        if (Number(redeemAmount.value) > 0) {
            fetchQuote();
        } else {
            setSimulatedExit(null);
        }
    }, [redeemAmount.value]);

    const submitRedeemAlt = form.handleSubmit(() => {
        openRedeemTransactionDialog({
            redeemAmount: Number(redeemAmount.value),
            redeemTokenId: selectedTokenId,
        });
    });

    return {
        redeemAmount,
        redeemAmountError,
        selectedTokenId,
        submitRedeemAlt,
        selectTokenId,
        setMaxAmount,
        simulatedExit,
        loadingSim,
        simError,
        isAmountOverBalance,
    };
}
